export default __webpack_public_path__ + "static/v4-styling-0d557c614ac6be2b1c997c048da6e443.png";